import { WS } from "../../../static/lib/synWebsocket";
import Vue from 'vue'

class RFIDServicer {
    constructor(syncData,pooled6c){
        this.ws = null
        this.init(syncData,pooled6c)
    }

    init(syncData,pooled6c){                //初始化
        console.log(window)
        this.ws = new WS("ws://127.0.0.1:9090/rfidService/1234");

        this.ws.onOpen = (e) => {
            console.log("webSocket连接成功");
            this.connectEvent()
        };
        this.ws.onClose = (e) => {
            console.log("webSocket连接关闭");
        };
        this.ws.onError = (e) => {
            console.log(e);
        };
        this.ws.handlerTagEpcLog = (res) => {
            pooled6c(res.data);
        };
        this.ws.handlerTagEpcOver = (res) => {
            syncData();
            console.log("handlerTagEpcOver");
        };
        this.ws.handlerTag6bLog = (res) => {
            // pooled6b(res.data);
        };
        this.ws.handlerTag6bOver = (res) => {
            syncData();
            console.log("handlerTag6bOver");
        };
        this.ws.handlerTagGbLog = (res) => {
            // pooledGb(res.data);
        };
        this.ws.handlerTagGbOver = (res) => {
            syncData();
            console.log("handlerTagGbOver");
        };
        this.ws.handlerTcpDisconnected = (res) => {
            console.log(res.data);
        };
        this.ws.handlerGpiStart = (res) => {
            console.log(res.data);
        };
        this.ws.handlerGpiOver = (res) => {
            console.log(res.data);
        };
    }
    connectEvent() {        //连接事件
        let msg = {
            wid: 4,
            baseOrApp: 2,
            data: {},
            msgId: 0x03,
        };
        this.ws.sendMsg(msg, (res) => {
            if (res.result == 0) {
                if (res.data.length) {
                    let param = res.data[0];
                    let msg2 = {
                        wid: 0,
                        data: param,
                        connectType: "4"
                    };
                    this.ws.sendMsg(msg2, (res) => {
                        // console.log(res);
                        if (res.result == 0) {
                            this.connectState = true;
                        } else {
                            this.connectState = false;
                        }
                    });
                } else {
                }
            } else {
                Vue.prototype.$message({
                    message: res.data,
                    type: 'error'
                })
            }
        })
    }
    readCard() {//读卡
        let msg = {
            wid: 4,
            baseOrApp: 0,
            data: {
                antennaEnable: 1,
                inventoryMode:1,
                readTid: {
                    mode: 0,
                    len: 6,
                }
            },
            msgId: 0x10,
        };
        this.ws.sendMsg(msg, (res) => {
            if (res.result == 0) {
                this.isStart = true;
            }
        });
    }
    pause() {           //停止
        let msg = {
            wid: 4,
            baseOrApp: 0,
            data: {},
            msgId: 0xFF,
        };
        this.ws.sendMsg(msg, (res) => {
            if (res.result == 0) {
                this.isStart = false;
            }
        });
    }
    writeEpcEvent(code,tid,success,fail) {
      code = window.getPc(code) + code
        let msg = {
            wid: 4,
            baseOrApp: 0,
            data: {
                antennaEnable: 1,
                area: 1,
                start: 1,
                hexWriteData: code,
            },
            msgId: 0x11,
        };
        if (tid) {//如果TID不为null则匹配写
            msg.data.filter = {
                area: 2,
                bitStart: 0,
                bitLength: tid.length * 4,
                hexData: tid
            }
        }
        this.ws.sendMsg(msg, res => {
            if (res.result == 0) {
                success('写入成功')
            } else {
                fail('写入失败')
            }
        });
    }
    disconnect() {//断开连接
        // this.ws.socket.close();
        let msg = {
            wid: 4,
            baseOrApp: 2,
            data: {},
            msgId: 0x00,
        };
        this.ws.sendMsg(msg, (res) => {
            if (res.result == 0) {
                this.connectState = false;
                this.connectHint = "未连接";
            }
        });
    }
}

export default RFIDServicer



// WEBPACK FOOTER //
// ./src/common/utils/RfidServicer.js